import { render, staticRenderFns } from "./ItemView.vue?vue&type=template&id=5e431599&scoped=true&"
import script from "./ItemView.vue?vue&type=script&lang=ts&"
export * from "./ItemView.vue?vue&type=script&lang=ts&"
import style0 from "./ItemView.vue?vue&type=style&index=0&id=5e431599&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e431599",
  null
  
)

export default component.exports